// NFL Team Names mapping - Abbreviation to Full Name
export const NFL_TEAM_NAMES: Record<string, string> = {
  // AFC East
  'BUF': 'Buffalo Bills',
  'MIA': 'Miami Dolphins',
  'NE': 'New England Patriots',
  'NYJ': 'New York Jets',
  
  // AFC North
  'BAL': 'Baltimore Ravens',
  'CIN': 'Cincinnati Bengals',
  'CLE': 'Cleveland Browns',
  'PIT': 'Pittsburgh Steelers',
  
  // AFC South
  'HOU': 'Houston Texans',
  'IND': 'Indianapolis Colts',
  'JAX': 'Jacksonville Jaguars',
  'TEN': 'Tennessee Titans',
  
  // AFC West
  'DEN': 'Denver Broncos',
  'KC': 'Kansas City Chiefs',
  'LV': 'Las Vegas Raiders',
  'LAC': 'Los Angeles Chargers',
  
  // NFC East
  'DAL': 'Dallas Cowboys',
  'NYG': 'New York Giants',
  'PHI': 'Philadelphia Eagles',
  'WAS': 'Washington Commanders',
  
  // NFC North
  'CHI': 'Chicago Bears',
  'DET': 'Detroit Lions',
  'GB': 'Green Bay Packers',
  'MIN': 'Minnesota Vikings',
  
  // NFC South
  'ATL': 'Atlanta Falcons',
  'CAR': 'Carolina Panthers',
  'NO': 'New Orleans Saints',
  'TB': 'Tampa Bay Buccaneers',
  
  // NFC West
  'ARI': 'Arizona Cardinals',
  'LAR': 'Los Angeles Rams',
  'SF': 'San Francisco 49ers',
  'SEA': 'Seattle Seahawks',
};
